import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOutlook = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	height: 24,
	viewBox: "0 0 27 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_5626_43854)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M26.7335 12.5995C26.7349 12.3978 26.6307 12.21 26.4587 12.1045H26.4557L26.4449 12.0985L17.5049 6.80652C17.4663 6.78044 17.4262 6.7566 17.3849 6.73513C17.0397 6.55704 16.6297 6.55704 16.2845 6.73513C16.2432 6.75661 16.2031 6.78044 16.1645 6.80652L7.22453 12.0985L7.21374 12.1045C6.94051 12.2744 6.85674 12.6337 7.02665 12.9069C7.07672 12.9874 7.14567 13.0545 7.22754 13.1023L16.1675 18.3943C16.2063 18.4202 16.2463 18.444 16.2875 18.4657C16.6327 18.6438 17.0427 18.6438 17.3879 18.4657C17.4292 18.444 17.4692 18.4202 17.5079 18.3943L26.4479 13.1023C26.6265 12.9982 26.7356 12.8063 26.7335 12.5995Z",
					fill: "#0A2767"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.26655 9.0666H14.1333V14.4444H8.26655V9.0666ZM25.5333 3.6V1.13999C25.5474 0.524937 25.0606 0.0147381 24.4456 0H9.22116C8.6061 0.0147381 8.11926 0.524937 8.13335 1.13999V3.6L17.1333 5.99999L25.5333 3.6Z",
					fill: "#0364B8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.1333 3.59961H14.1333V8.9996H8.1333V3.59961Z",
					fill: "#0078D4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.1333 3.59961H14.1333V8.9996L20.1333 14.3996H25.5333V8.9996L20.1333 3.59961Z",
					fill: "#28A8EA"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.1333 9H20.1333V14.4H14.1333V9Z",
					fill: "#0078D4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M14.1333 14.4004H20.1333V19.8004H14.1333V14.4004Z",
					fill: "#0364B8"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.2666 14.4443H14.1334V19.3331H8.2666V14.4443Z",
					fill: "#14447D"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.1333 14.4004H25.5333V19.8004H20.1333V14.4004Z",
					fill: "#0078D4"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.4585 13.0694L26.4471 13.0754L17.5071 18.1034C17.4681 18.1274 17.4285 18.1502 17.3871 18.1706C17.2353 18.2429 17.0704 18.2837 16.9023 18.2906L16.4139 18.005C16.3727 17.9843 16.3326 17.9613 16.2939 17.936L7.23395 12.7652H7.22975L6.93335 12.5996V22.778C6.93797 23.4571 7.49206 24.0039 8.17114 23.9996H25.5147C25.5249 23.9996 25.5339 23.9948 25.5447 23.9948C25.6882 23.9856 25.8296 23.9561 25.9647 23.9072C26.0231 23.8825 26.0795 23.8532 26.1333 23.8196C26.1735 23.7968 26.2425 23.747 26.2425 23.747C26.5499 23.5196 26.7318 23.1604 26.7333 22.778V12.5996C26.7331 12.7943 26.6281 12.9738 26.4585 13.0694Z",
					fill: "url(#paint0_linear_5626_43854)"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .5,
					d: "M26.2532 12.5594V13.1835L16.9053 19.6196L7.22725 12.7694C7.22725 12.7661 7.22456 12.7634 7.22125 12.7634L6.33325 12.2294V11.7794L6.69925 11.7734L7.47325 12.2174L7.49124 12.2234L7.55724 12.2654C7.55724 12.2654 16.6532 17.4554 16.6772 17.4674L17.0252 17.6714C17.0552 17.6594 17.0852 17.6474 17.1212 17.6354C17.1392 17.6234 26.1512 12.5534 26.1512 12.5534L26.2532 12.5594Z",
					fill: "#0A2767"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.4585 13.0694L26.4471 13.076L17.5071 18.104C17.4681 18.128 17.4285 18.1508 17.3871 18.1712C17.0399 18.3408 16.6339 18.3408 16.2867 18.1712C16.2456 18.1508 16.2056 18.1284 16.1667 18.104L7.22675 13.076L7.21595 13.0694C7.04335 12.9758 6.93514 12.7959 6.93335 12.5996V22.778C6.93765 23.457 7.49154 24.0039 8.17049 23.9996C8.17049 23.9996 8.17052 23.9996 8.17055 23.9996H25.4961C26.1751 24.0039 26.729 23.457 26.7333 22.7781C26.7333 22.7781 26.7333 22.778 26.7333 22.778V12.5996C26.7331 12.7943 26.6281 12.9738 26.4585 13.0694Z",
					fill: "#1490DF"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M17.6375 18.0303L17.5037 18.1053C17.4649 18.13 17.4249 18.1526 17.3837 18.1731C17.2363 18.2454 17.076 18.2879 16.9121 18.2979L20.3135 22.3203L26.2469 23.7501C26.4095 23.6273 26.5388 23.4658 26.6231 23.2803L17.6375 18.0303Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .05,
					d: "M18.2435 17.6895L17.5037 18.1052C17.4649 18.1299 17.4249 18.1526 17.3837 18.1731C17.2363 18.2454 17.076 18.2878 16.9121 18.2978L18.5057 22.6916L26.2487 23.7482C26.5537 23.5192 26.7333 23.1601 26.7335 22.7786V22.6472L18.2435 17.6895Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.18735 23.9996H25.4943C25.7606 24.0009 26.0204 23.9168 26.2353 23.7596L16.4133 18.0062C16.3721 17.9855 16.332 17.9625 16.2933 17.9372L7.23334 12.7664H7.22914L6.93335 12.5996V22.7432C6.93267 23.4364 7.4941 23.9989 8.18735 23.9996Z",
					fill: "#28A8EA"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .1,
					d: "M15.3333 5.8996V18.6976C15.3323 19.1463 15.0594 19.5496 14.6433 19.7176C14.5144 19.773 14.3756 19.8016 14.2353 19.8016H6.93335V5.3998H8.13335V4.7998H14.2354C14.8415 4.8021 15.332 5.29345 15.3333 5.8996Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M14.7334 6.49926V19.2972C14.7349 19.4422 14.7041 19.5857 14.6433 19.7172C14.4767 20.1279 14.0786 20.3974 13.6353 20.3994H6.93335V5.39946H13.6353C13.8094 5.39772 13.981 5.44114 14.1333 5.52547C14.5011 5.71077 14.7332 6.08742 14.7334 6.49926Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M14.7334 6.49926V18.0973C14.7304 18.7031 14.2412 19.1942 13.6354 19.1994H6.93335V5.39946H13.6353C13.8094 5.39772 13.981 5.44114 14.1333 5.52547C14.5011 5.71077 14.7332 6.08742 14.7334 6.49926Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					opacity: .2,
					d: "M14.1333 6.50019V18.0982C14.1327 18.705 13.6422 19.1974 13.0354 19.2004H6.93335V5.40039H13.0353C13.6421 5.40071 14.1337 5.89285 14.1333 6.49959C14.1333 6.49979 14.1333 6.49999 14.1333 6.50019Z",
					fill: "black"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M2.03315 5.40039H13.0335C13.6409 5.40039 14.1333 5.89279 14.1333 6.50019V17.5006C14.1333 18.108 13.6409 18.6004 13.0335 18.6004H2.03315C1.42574 18.6004 0.93335 18.108 0.93335 17.5006V6.50019C0.93335 5.89279 1.42575 5.40039 2.03315 5.40039Z",
					fill: "url(#paint1_linear_5626_43854)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M4.37067 10.0128C4.64173 9.43529 5.07926 8.95199 5.62708 8.62502C6.23375 8.27769 6.9245 8.10454 7.62328 8.12461C8.27093 8.11057 8.90999 8.27474 9.47068 8.59921C9.99784 8.91358 10.4224 9.37422 10.6929 9.92521C10.9874 10.5323 11.1342 11.2005 11.1213 11.8752C11.1356 12.5803 10.9845 13.279 10.6803 13.9152C10.4034 14.4859 9.96533 14.9629 9.42028 15.2874C8.83798 15.6218 8.17518 15.7903 7.50388 15.7746C6.8424 15.7906 6.18924 15.6245 5.61568 15.2946C5.08395 14.9798 4.65405 14.5187 4.37728 13.9662C4.08099 13.3678 3.93246 12.7072 3.94408 12.0396C3.93174 11.3405 4.07757 10.6476 4.37067 10.0128ZM5.70987 13.2708C5.85439 13.6359 6.09947 13.9526 6.41667 14.184C6.73975 14.4098 7.12662 14.5263 7.52066 14.5164C7.9403 14.533 8.35394 14.4125 8.69907 14.1732C9.01224 13.9425 9.25089 13.625 9.38546 13.26C9.5359 12.8524 9.61014 12.4206 9.60446 11.9862C9.60911 11.5476 9.53932 11.1114 9.39806 10.6962C9.27329 10.3213 9.04234 9.99074 8.73326 9.74461C8.39679 9.49395 7.98426 9.36682 7.56506 9.38461C7.16248 9.37419 6.76694 9.4916 6.43527 9.72001C6.1127 9.95244 5.86297 10.2719 5.71527 10.641C5.3876 11.4871 5.3859 12.4247 5.71046 13.272L5.70987 13.2708Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.1333 3.59961H25.5333V8.9996H20.1333V3.59961Z",
					fill: "#50D9FF"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_5626_43854",
				x1: 16.8333,
				y1: 12.5996,
				x2: 16.8333,
				y2: 23.9996,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#35B8F1" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#28A8EA"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_5626_43854",
				x1: 3.22645,
				y1: 4.54103,
				x2: 11.8402,
				y2: 19.4597,
				gradientUnits: "userSpaceOnUse",
				children: [
					/* @__PURE__ */ _jsx("stop", { stopColor: "#1784D9" }),
					/* @__PURE__ */ _jsx("stop", {
						offset: .5,
						stopColor: "#107AD5"
					}),
					/* @__PURE__ */ _jsx("stop", {
						offset: 1,
						stopColor: "#0A63C9"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_5626_43854",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 25.8,
					height: 24,
					fill: "white",
					transform: "translate(0.93335)"
				})
			})
		] })
	]
});
const ForwardRef = forwardRef(SvgOutlook);
export { ForwardRef as ReactComponent };
